module.exports = __webpack_public_path__ + "static/media/Illus-Employee_4@2x.241eb5e3.png";